import type { StyleRule } from '@vanilla-extract/css';

export const lightModeClass = 'light';
export const darkModeClass = 'dark';

interface ResponsiveStyles {
  tablet?: StyleRule;
  desktop?: StyleRule;
}

export const responsiveStyle = ({ tablet, desktop }: ResponsiveStyles) => ({
  '@media': {
    'screen and (min-width: 768px)': tablet || {},
    'screen and (min-width: 1024px)': desktop || {},
  },
});

export const breakpoints = {
  mobile: '(max-width:767px)',
  tablet: '(min-width: 768px)',
  desktop: '(min-width: 1024px)',
};
